import React, {useState} from "react";
import {gql, useQuery} from "@apollo/client";
import FilterToolbar from "../../../../ui/filters/FilterToolbar";
import Tools from "../../../../../Tools";

const UpcomingMatchesFilters = props => {
    const query = gql`
        query getFilters($regions: [String!], $countries: [String!]){
            regions: getRegions{
                id
                name
            }

            countries: getCountries(regions: $regions) {
                id
                name
            }

            competitions: competitions{
                id
                name
            }

            teams: teams{
                id
                name
            }

            stadiums: getStadiums (countries: $countries){
                id
                name
            }
        }
    `;

    const [regions, setRegions] = useState([]);
    const [countries, setCountries] = useState([]);

    const variables = {
        regions: Tools.convertEmptyToNull(regions),
        countries: Tools.convertEmptyToNull(countries),
    };

    const {loading, error, data} = useQuery(query, {
        variables: variables
    });

    const filterFormatter = filter => {
        if (!filter)
            return [];

        return filter.map(option => ({
            key: option.id,
            value: option.id,
            label: option.name,
        }))
    };

    const withSelectAll = (options, label = 'Select all') => options.length === 0 ? [] : [{key: 'all', value: 'all', label: label}, ...options];

    const config = [
        {
            placeholder: 'All Regions',
            name: 'regions',
            type: 'multiple-select',
            options: withSelectAll(filterFormatter(data?.regions), 'Select all Regions'),
            onChange: options => setRegions(options.map(option => option.value)),
            withSearch: true,
            selected: true,
            span: {xs: 12, md: 6, lg: 'auto'},
        },
        {
            placeholder: 'All Countries',
            name: 'countries',
            type: 'multiple-select',
            options: withSelectAll(filterFormatter(data?.countries), 'Select all Countries'),
            onChange: options => setCountries(options.map(option => option.value)),
            withSearch: true,
            selected: true,
            span: {xs: 12, md: 6, lg: 'auto'},
        },
        {
            placeholder: ' All Competitions',
            name: 'competitions',
            type: 'multiple-select',
            options: withSelectAll(filterFormatter(data?.competitions), 'Select all Competitions'),
            withSearch: true,
            selected: true,
            span: {xs: 12, md: 6, lg: 'auto'},
        },
        {
            placeholder: 'All Teams',
            name: 'teams',
            type: 'multiple-select',
            options: withSelectAll(filterFormatter(data?.teams), 'Select all Teams'),
            withSearch: true,
            selected: true,
            span: {xs: 12, md: 6, lg: 'auto'},
        },
        {
            placeholder: 'All venues',
            name: 'venues',
            type: 'multiple-select',
            options: withSelectAll(filterFormatter(data?.stadiums), 'Select all venues'),
            withSearch: true,
            selected: true,
            span: {xs: 12, md: 6, lg: 'auto'},
        },
        {
            placeholder: 'Search Matches, Leagues, Venue, Team...etc',
            name: 'search',
            type: 'search',
            align: 'right',
            span: {xs: 12, md: 6, lg: 3},
        },
    ];

    return (
        <FilterToolbar loading={loading} error={error} filters={config} size="sm" color="primary" onChange={props.onChange}/>
    );
};

export default UpcomingMatchesFilters;
